import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateFinixTransactionRequestSchema,
  TCreateFinixTransactionResponseSchema,
} from "./createFinixTransaction.schema";

export const createFinixTransaction = (axios: IAxiosInstance) => {
  return async (body: TCreateFinixTransactionRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreateFinixTransactionResponseSchema>
    >(`/api/business-cards/transaction`, body);

    return response.data;
  };
};
